/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: 'لم يتم العثور على سجلات.',
  DocumentIndex: 'فهرس الوثائق',
  SubmissionIndex: 'فهرس التقديم',
  Search: 'بحث',
  Searching: 'البحث...',
  Filter: 'راووق',
  FullTextSearch_SentenceCase: 'البحث عن النص الكامل',
  BulkDownload_SentenceCase: 'تحميل بالجملة',
  ExportToExcel: 'تصدير إلى Excel',
  ExpandAll_SentenceCase: 'توسيع الكل',
  CollapseAll_SentenceCase: 'طي الكل',
  BulkDownloadName_SentenceCase: 'اسم الحزمة',
  SelectAll_SentenceCase: 'حدد الكل',
  AskQuestion: 'اطرح سؤالا',
  Move: 'حرك',
  Edit: 'حرر',
  OpenInOfficeOnline: 'فتح في Microsoft Office للويب',
  EditInOfficeOnline: 'التحرير في Microsoft Office للويب',
  Security: 'أمن',
  Enable: 'تمكين',
  Disable: 'تعطيل',
  Delete: 'حذف',
  History: 'تاريخ',
  History_LowerCase: 'تاريخ',
  ManageDocuments: 'إدارة المستندات',
  SelectDocumentsToRedact: 'حدد المستندات المراد تنقيحها',
  Submissions: 'الطلبات',
  TenderSubmissions: 'تقديم العطاءات',
  Add: 'جمع',
  Folder: 'مجلد',
  Document: 'مستند',
  Document_LowerCase: 'مستند',
  Documents_LowerCase: 'الوثائق',
  Folder_LowerCase: 'مجلد',
  Folders_LowerCase: 'المجلدات',
  Renumber: 'يعاد ترقيم',
  BulkUpload_SentenceCase: 'تحميل مجمع',
  BulkDownloadOverDownloadLimit:
    'لقد وصلت إلى حد حجم التنزيل البالغ 100 جيجابايت. الرجاء إزالة الملفات من التحديد للمتابعة.',
  Name_: 'اسم:',
  Number_: 'رقم:',
  Retry: 'اعاده المحاوله',
  FolderNotDeletedAccess:
    'خطأ: تعذر حذف المجلد لأنه يحتوي على مستند واحد أو أكثر و/أو مجلدات فرعية غير مسموح لك بالوصول إليها.',
  FolderNotDeleted: 'خطأ: تعذر حذف المجلد.',
  DocumentNotDeleted: 'خطأ: تعذر حذف المستند.',
  FolderNotUpdated: 'خطأ: تعذر تحديث المجلد.',
  DocumentNotUpdated: 'خطأ: تعذر تحديث المستند.',
  ParentFolderDisabled: 'تم تعطيل المجلد الأصل',
  EnableDocument:
    'يحتوي هذا المجلد على مستند 1 ، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  EnableDocuments: '\u003cb\u003eتمكين\u003c/b\u003eالمستندات',
  EnableFolder:
    'يحتوي هذا المجلد على مجلد 1 ، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  EnableFolderDocument:
    'يحتوي هذا المجلد على مجلد 1 ومستند 1 ، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  EnableFolderDocuments:
    'يحتوي هذا المجلد على 1 مجلد و ${NumberOfDocuments} مستندات، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  EnableFolders:
    'يحتوي هذا المجلد على ${NumberOfFolders} مجلدات ، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  EnableFoldersDocument:
    'يحتوي هذا المجلد على مجلدات ${NumberOfFolders} ومستند 1 ، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  EnableFoldersDocuments:
    'يحتوي هذا المجلد على ${NumberOfFolders} المجلدات والمستندات ${NumberOfDocuments} ، هل أنت متأكد من أنك تريد تمكين هذا المجلد؟',
  BulkEnableFolders: 'سيتم تمكين ${NumberOfFolders} المجلدات.',
  BulkEnableFoldersWithImplicitFolders:
    'لتمكين هذه العناصر ، يجب تمكين جميع المجلدات الأصل. سيتم تمكين ${NumberOfFolders} المجلدات.',
  BulkEnableOneFolder: 'سيتم تمكين مجلد 1.',
  BulkEnableOneFolderAndDocuments:
    'سيتم تمكين 1 مجلد والمستندات ${NumberOfDocuments}.',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    'لتمكين هذه العناصر ، يجب تمكين جميع المجلدات الأصل. سيتم تمكين 1 مجلد والمستندات ${NumberOfDocuments}.',
  BulkEnableOneFolderAndOneDocument: 'سيتم تمكين مجلد 1 ومستند 1.',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    'لتمكين هذه العناصر ، يجب تمكين جميع المجلدات الأصل. سيتم تمكين مجلد 1 ومستند 1.',
  BulkEnableDocuments: 'سيتم تمكين ${NumberOfDocuments} المستندات.',
  BulkEnableOneDocument: 'سيتم تمكين مستند 1.',
  BulkEnableFoldersAndOneDocument:
    'سيتم تمكين ${NumberOfFolders} المجلدات ومستند 1.',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    'لتمكين هذه العناصر ، يجب تمكين جميع المجلدات الأصل. سيتم تمكين ${NumberOfFolders} المجلدات ومستند 1.',
  BulkEnableFoldersAndDocuments:
    'سيتم تمكين ${NumberOfFolders} المجلدات والمستندات ${NumberOfDocuments}.',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    'لتمكين هذه العناصر ، يجب تمكين جميع المجلدات الأصل. سيتم تمكين ${NumberOfFolders} المجلدات والمستندات ${NumberOfDocuments}.',
  BulkEnableDocumentsErrorMessage:
    'خطأ: تعذر تمكين المستند (المستندات) ${NumberOfDocuments}.',
  BulkEnableFoldersErrorMessage:
    'خطأ: تعذر تمكين مجلد (مجلدات) ${NumberOfFolders}.',
  BulkEnableFoldersDocumentsErrorMessage:
    'خطأ: تعذر تمكين المجلد (المجلدات) ${NumberOfFolders} والمستند (المستندات) ${NumberOfDocuments}.',
  DisableDocument:
    'يحتوي هذا المجلد على مستند 1 ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableDocuments: '\u003cb\u003eتعطيل\u003c/b\u003eالمستندات',
  DisableFolder:
    'يحتوي هذا المجلد على مجلد 1 ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableFolderDocument:
    'يحتوي هذا المجلد على مجلد 1 ومستند 1 ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableFolderDocuments:
    'يحتوي هذا المجلد على مجلد 1 و ${NumberOfDocuments} مستند ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableFolders:
    'يحتوي هذا المجلد على ${NumberOfFolders} مجلدات ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableFoldersDocument:
    'يحتوي هذا المجلد على ${NumberOfFolders} مجلدات ومستند 1 ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableFoldersDocuments:
    'يحتوي هذا المجلد على ${NumberOfFolders} مجلدات ومستندات ${NumberOfDocuments} ، هل أنت متأكد من أنك تريد تعطيل هذا المجلد؟',
  DisableFolderConfirm:
    'يحتوي مجلد "${FolderName}" على مجلدات أخرى بداخله ، وسيتم تعطيلها أيضا.',
  BulkDisableFolders: 'سيتم تعطيل ${NumberOfFolders} المجلدات.',
  BulkDisableOneFolder: 'سيتم تعطيل مجلد 1.',
  BulkDisableOneFolderAndDocuments:
    'سيتم تعطيل مجلد 1 والمستندات ${NumberOfDocuments}.',
  BulkDisableOneFolderAndOneDocument: 'سيتم تعطيل مجلد 1 ومستند 1.',
  BulkDisableDocuments: 'سيتم تعطيل المستندات ${NumberOfDocuments}.',
  BulkDisableOneDocument: 'سيتم تعطيل المستند 1.',
  BulkDisableFoldersAndOneDocument:
    'سيتم تعطيل المجلدات ${NumberOfFolders} ومستند 1.',
  BulkDisableFoldersAndDocuments:
    'سيتم تعطيل المجلدات ${NumberOfFolders} والمستندات ${NumberOfDocuments}.',
  BulkDisableDocumentsErrorMessage:
    'خطأ: تعذر تعطيل المستند (المستندات) ${NumberOfDocuments}.',
  BulkDisableFoldersErrorMessage:
    'خطأ: تعذر تعطيل مجلد (مجلدات) ${NumberOfFolders}.',
  BulkDisableFoldersDocumentsErrorMessage:
    'خطأ: تعذر تعطيل المجلد (المجلدات) ${NumberOfFolders} والمستند (المستندات) ${NumberOfDocuments}.',
  DeleteFileConfirmation: 'سيتم حذف "${FileName}" على الفور.',
  DeleteFolderConfirmation: 'سيتم حذف "${FolderName}" على الفور.',
  BulkDeleteFolders: 'سيتم حذف ${NumberOfFolders} المجلدات.',
  BulkDeleteOneFolder: 'سيتم حذف مجلد 1.',
  BulkDeleteOneFolderAndDocuments:
    'سيتم حذف 1 مجلد و ${NumberOfDocuments} مستندات.',
  BulkDeleteOneFolderAndOneDocument: 'سيتم حذف 1 مجلد ومستند 1.',
  BulkDeleteDocuments: 'سيتم حذف المستندات ${NumberOfDocuments}.',
  BulkDeleteOneDocument: 'سيتم حذف 1 وثيقة.',
  BulkDeleteFoldersAndOneDocument:
    'سيتم حذف المجلدات ${NumberOfFolders} ومستند 1.',
  BulkDeleteFoldersAndDocuments:
    'سيتم حذف المجلدات ${NumberOfFolders} والمستندات ${NumberOfDocuments}.',
  BulkDeleteDocumentsErrorMessage:
    'خطأ: تعذر حذف المستند (المستندات) ${NumberOfDocuments}.',
  BulkDeleteFoldersErrorMessage:
    'خطأ: تعذر حذف مجلد (مجلدات) ${NumberOfFolders}.',
  BulkDeleteFoldersDocumentsErrorMessage:
    'خطأ: تعذر حذف مجلد (مجلدات) ${NumberOfFolders} ومستند (مستندات) ${NumberOfDocuments}.',
  AddFolder: 'إضافة مجلد',
  AddDocument: 'إضافة مستند',
  CopyLink_SentenceCase: 'نسخ الرابط',
  SendToKira_SentenceCase: 'إرسال إلى كيرا',
  Actions: 'الاجراءات',
  Download: 'تحميل',
  DownloadPart: 'تنزيل الجزء ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    'لم يتم تشغيل التنزيل المجمع. اتصل بالمسؤول للحصول على مزيد من المعلومات',
  Disabled: 'ذوي الاحتياجات الخاصه',
  FileTypeUnknown: 'ملف',
  FileTypeAcrobat: 'أكروبات PDF',
  FileTypeArchive: 'أرشيف',
  FileTypeAudio: 'ملف صوتي',
  FileTypeCode: 'رمز',
  FileTypeContact: 'الاتصال',
  FileTypeEmail: 'البريد الإلكتروني',
  FileTypeExcel: 'اكسل',
  FileTypeImage: 'صورة',
  FileTypeLayoutAndDesign: 'وثيقة التصميم',
  FileTypePowerpoint: 'باوربوينت',
  FileTypeText: 'نص',
  FileTypeVideo: 'فيديو',
  FileTypeVisio: 'Visio',
  FileTypeWord: 'كلمة',
  SavingAllowed: 'التوفير مسموح به',
  SavingDenied: 'رفض الادخار',
  PrintingAllowed: 'الطباعة مسموح بها',
  PrintingDenied: 'تم رفض الطباعة',
  FileExtensionEmpty: 'لا يوجد تمديد',
  OneBulkDownloadInProgress: '1 تنزيل مجمع قيد التقدم - ${progress}٪',
  NumberOfBulkDownloadInProgress:
    '${number} تنزيلات مجمعة قيد التقدم - ${progress}٪',
  Cancel: 'إلغاء الأمر',
  Expand: 'ستوسع',
  Collapse: 'تقوض',
  FolderEmpty: 'مجلد فارغ',
  UseChromeToBulkUpload: 'استخدم Chrome لتحميل المستندات والمجلدات بشكل مجمع.',
  RenumberCallToAction: 'يعاد ترقيم',
  Archives: 'المحفوظات',
  BulkDownloadUnavailable:
    'التنزيل المجمع غير متوفر حاليا. يرجى إعادة المحاولة لاحقا',
  PreviewNotAvailable: 'المعاينة غير متوفرة',
  DocumentIsTooLargeToPreview:
    'هذا المستند كبير جدا بحيث لا يمكن معاينته. تحتاج إلى تنزيل المستند لعرضه.',
  DocumentIsTooLargeToPreviewWithoutDownload:
    'هذا المستند كبير جدا بحيث لا يمكن معاينته',
  FileCannotBePreviewed: 'لا يمكن معاينة هذا الملف.',
  OwnerHasSecuredThisDocument: 'قام المالك بتأمين هذا المستند',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    'يتم تأمين هذا المستند باستخدام إدارة حقوق Adobe. تحتاج إلى Adobe Acrobat Reader وأن تكون متصلا بالإنترنت لعرض هذا المستند.',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    'يتم تأمين هذا المستند باستخدام إدارة حقوق Microsoft. تحتاج إلى Microsoft Office وأن تكون متصلا بالإنترنت لعرض هذا المستند.',
  SecuredPdfHelpLink:
    'تعرف على المزيد حول \u003ca href=\u0022https://help.ansarada.com/troubleshoot/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eعرض مستندات PDF.\u003c/a\u003e',
  SecuredPdfHelpLinkMac:
    'تعرف على المزيد حول \u003ca href=\u0022https://help.ansarada.com/troubleshoot/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eعرض مستندات PDF.\u003c/a\u003e',
  SecuredDocHelpLink:
    'تعرف على المزيد حول \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eعرض مستندات المكتب.\u003c/a\u003e',
  YourDownloadIsBeingPrepared: 'يتم إعداد التنزيل الخاص بك ...',
  OwnerHasSecuredTheseDocuments: 'قام المالك بتأمين هذه المستندات',
  SecuredPdfAndDocHelpLink:
    'تعرف على المزيد حول \u003ca href=\u0022https://help.ansarada.com/troubleshoot/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eعرض مستندات PDF\u003c/a\u003eor \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eمستندات المكتب.\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    'تعرف على المزيد حول \u003ca href=\u0022https://help.ansarada.com/troubleshoot/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eعرض مستندات PDF\u003c/a\u003eor \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eمستندات المكتب.\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    'يتم تأمين هذه المستندات باستخدام إدارة حقوق Adobe أو إدارة حقوق Microsoft. تحتاج إلى Adobe Acrobat Reader أو Microsoft Office وتكون متصلا بالإنترنت لعرض هذه المستندات.',
  UnableToDownloadThisFileTryAgain: 'غير قادر على تنزيل هذا الملف.',
  DownloadStarted: 'بدأ التنزيل',
  Close: 'غلق',
  GotIt: 'فهمت ذلك',
  Preview: 'معاينه',
  DontShowThisAgain: 'لا تظهر هذا مرة أخرى',
  BulkDownloadPrepareTitle: 'يتم إعداد التنزيل الخاص بك ...',
  BulkDownloadPrepareAwareMessage:
    'يرجى الانتباه إلى أنه كلما زاد حجم التنزيل ، زادت مدة المعالجة.',
  BulkDownloadPrepareMessage:
    'سيتم إرسال بريد إلكتروني إلى <strong>${email}</strong> عندما يكون التنزيل جاهزا.',
  BulkDownloadLimitError:
    'لقد وصلت إلى حد تنزيل ملفات ${limitedNumberOfItems} أو ${limitedFileSize}. الرجاء إزالة الملفات من التحديد للمتابعة.',
  LinkCopiedToClipboard: 'تم نسخ الرابط إلى الحافظة',
  RestoreDocuments: 'استعادة المستندات',
  RepairNumbering: 'ترقيم الإصلاح',
  BulkUpdate: 'تحديث مجمع',
  GenerateFolders: 'إنشاء مجلدات',
  NotificationsReport: 'تقرير الإشعارات',
  DownloadHelpInfo: 'إذا لم يبدأ التنزيل بعد بضع ثوان ، فيرجى استخدام ملف',
  DirectLink: 'رابط مباشر',
  YourDocumentsAreDownloading: 'يتم تنزيل مستنداتك.',
  DocumentRenamed: 'تمت إعادة تسمية الوثيقة.',
  FolderRenamed: 'تمت إعادة تسمية المجلد.',
  FolderRenamedRenumber: 'إعادة الترقيم لتحديث محتويات المجلد',
  DocumentsNotificationList: 'قائمة إشعارات المستندات',
  UserDocumentNotificationSettings: 'إعدادات إعلامات مستندات المستخدم',
  IntervalType: 'نوع الفاصل الزمني',
  NumberOfUsers: 'عدد المستخدمين',
  NotificationList: 'قائمة الإخطارات',
  ExportSelectedItemsToExcel: 'تصدير [الرقم] إلى Excel',
  ToEmail: 'إلى البريد الإلكتروني',
  FromSentDateSydneyTime: 'من تاريخ الإرسال (توقيت سيدني)',
  ToSentDateSydneyTime: 'إلى تاريخ الإرسال (توقيت سيدني)',
  DocID: 'معرف المستند',
  DocName: 'اسم المستند',
  To: 'ل',
  UserType: 'نوع المستخدم',
  SentDateSydneyTime: 'تاريخ الإرسال (توقيت سيدني)',
  Previous: 'سابق',
  Next: 'مقبل',
  DisableFolderConfirmHeader: 'أنت على وشك تعطيل مجلد',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    'لا توجد مستندات أو مجلدات متاحة في الوقت الحالي.',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    'لا توجد مستندات أو مجلدات مطابقة لمعايير التصفية.',
  DeleteFolderConfirmHeader: 'أنت على وشك حذف مجلد',
  DeleteFileConfirmHeader: 'أنت على وشك حذف ملف',
  MoveItemDialogUseDestinationFolderSecurity:
    'استخدام إعدادات أمان المجلد من ${destinationFolderName}',
  MoveItemDialogSecuritySettingsLabel: 'إعدادات الأمان',
  MoveItemDialogUseCurrentFolderSecurity: 'استخدام إعدادات الأمان الحالية',
  MoveItemDialogNotifyCheckbox: 'إعلام الأشخاص عند منح حق الوصول',
  MoveItemNewLocation: 'الموقع الجديد: ',
  DontHavePermissionToMoveFolder: 'ليس لديك إذن لنقل هذا المجلد.',
  DontHavePermissionToMoveFolders: 'ليس لديك إذن لنقل هذه المجلدات.',
  DontHavePermissionToMoveItemsMoveIntoFolder:
    'ليس لديك إذن لنقل العناصر إلى هذا المجلد.',
  SecuredFileIsTooLargeToPreview:
    'الملف الذي تحاول معاينته كبير جدا. يمكنك تنزيله بدلا من ذلك.',
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    'الملف الذي تحاول معاينته كبير جدا.',
  BeforeYouDownload: 'قبل التنزيل',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshoot/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eتعرف على المزيد حول عرض مستندات PDF.\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshoot/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eتعرف على المزيد حول عرض مستندات PDF.\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eتعرف على المزيد حول عرض مستندات Office.\u003c/a\u003e',
  StartYourDataRoomAndAddDocument: 'ابدأ تشغيل غرفة البيانات وأضف المستندات.',
  UploadDocuments: 'تحميل المستندات',
  ExpiredDocumentAccess:
    'انتهت صلاحية وصولك إلى هذا المستند. اتصل بمسؤول غرفة البيانات للحصول على حق الوصول.',
  MultipleDragDropInfo: 'تحديد وسحب وإسقاط المستندات والمجلدات لنقلها',
  DemoMultipleDragDropTitle: 'كيف تعمل',
  Zipping: 'فتح سوسته',
  Processing: 'تجهيز...',
  YourFilesAreReadyToDownload: 'ملفاتك جاهزة للتنزيل',
  ThisBulkDownloadIsSplit:
    'هذا التنزيل كبير جدا وقد قسمناه إلى أجزاء متعددة. يمكن أيضا العثور على هذه الروابط في بريدك الإلكتروني.',
  BulkDownloadEmptyFoldersNote: 'لن يتم تنزيل المجلدات الفارغة.',
  NotifyPeopleWhenAccessIsGranted: 'إعلام الأشخاص عند منح حق الوصول',
  BulkEnableConfirmHeader: 'تمكين المجلدات والمستندات',
  BulkDisableConfirmHeader: 'تعطيل المجلدات والمستندات',
  CopyDocumentsInProgress: 'تحميل فهرس المستند قيد التقدم',
  SomeDocumentsAreSecuredLink:
    'يتم تأمين بعض المستندات من قبل المسؤول. لفتحها تحتاج:',
  EnableTruncation: 'تمكين الاقتطاع',
  OptimizeFilePathForWindows: 'تحسين مسار الملف لنظام التشغيل Windows',
  TruncationNoteForWindows:
    'بالنسبة لمستخدمي Windows ، تحتاج إلى استخدام 7-Zip على نظام التشغيل Windows 10 للاستخراج.',
  Restore: 'يستعيد',
  Current: 'حالي',
  AddedBy: 'أضيفت من قبل',
  UpdatedBy: 'تم التحديث بواسطة',
  RestoreThisVersion: 'استعادة هذا الإصدار',
  AdobeAcrobatReader: 'أدوبي أكروبات ريدر',
  MicrosoftOffice: 'مايكروسوفت أوفيس',
  InternetConnection: 'اتصال بالإنترنت',
  BulkDeleteConfirmHeader: 'حذف المجلدات والمستندات',
  Preparing: 'اعداد...',
  SomeSavingDeniedFilesSelected:
    '${number} المستندات التي تحتوي على سياسة "تم رفض الحفظ" ولن يتم تنزيلها.',
  RestoreDocumentSuccessMessage: 'تم استعادة ${title}',
  RestoreVersionNumberButtonText: 'استعادة الإصدار ${versionNumber}',
  HistoryDialogNothingChangeMessage: 'هذا الإصدار هو نفس الإصدار الحالي',
  HistoryDialogNoDocumentChangeMessage: 'لم يتم تغيير محتوى المستند',
  HistoryDialogNoNameAndNumberChangeMessage: 'لم يتم تغيير اسم ورقم المستند',
  ResetViewAsToDownload: 'إعادة تعيين مرشح "عرض ك" للتنزيل.',
  NoPermissionToDownloadTooltip:
    'قام المسؤول بتعطيل التنزيل المجمع لهذه الغرفة',
  Remove: 'أبعد',
  Reset: 'اعاده تعيين',
  ResetNow: 'إعادة التعيين الآن',
  ResetDialogTitle: 'إعادة تعيين عملية الإرسال',
  ResetDialogContent:
    'هل أنت متأكد من أنك تريد إعادة تعيين عملية الإرسال؟ سيتم إعادة تعيين تاريخ ووقت الإغلاق.',
  Confirm: 'أكد',
  Region: 'قطر',
  KiraSuccessfullyConnectedTitle: 'تم الاتصال بنجاح بكيرا',
  KiraSuccessfullyConnectedFirstLine:
    'يمكنك الآن إرسال المستندات إلى Kira للكشف عنها',
  KiraSuccessfullyConnectedSecondLine:
    'المعلومات ذات الصلة من العقود والوثائق ذات الصلة.',
  KiraProjectsLoading: 'جاري تحميل المشاريع...',
  KiraSelectProject: 'اختر مشروعا في كيرا...',
  KiraSendDocument: 'إرسال مستند إلى كيرا',
  KiraConnect: 'الاتصال بكيرا',
  KiraCompanyUrl: 'عنوان URL الخاص بشركة كيرا',
  KiraApiToken: 'رمز كيرا API',
  KiraUnableToConnect:
    'لم نتمكن من الاتصال بكيرا. يرجى التحقق من منطقتك والرمز المميز والمحاولة مرة أخرى.',
  KiraConfigError: 'حدث خطأ ما في تكوين التحميل. يرجى المحاولة مرة أخرى.',
  KiraProjectsLoadError:
    'لم نتمكن من جلب مشاريعك من كيرا. يرجى المحاولة مرة أخرى.',
  KiraSendDocumentError:
    'حدث خطأ ما في دفع المستند إلى كيرا. يرجى المحاولة مرة أخرى.',
  KiraSendingDocument: "إرسال '${documentName}' إلى كيرا",
  KiraDocumentSent: "إرسال '${documentName}' إلى كيرا",
  Redact: 'ريداكت',
  RedactDocuments: 'تنقيح المستندات',
  EditRedact: 'تحرير التنقيح',
  RedactionIsNotAvailable: 'التنقيح غير متوفر',
  RedactGetDocumentError:
    'لم نتمكن من الحصول على هذا المستند. يرجى المحاولة مرة أخرى',
  RedactBurnDocumentError:
    'لم نتمكن من تنقيح هذه الوثيقة. يرجى المحاولة مرة أخرى',
  RedactFileTooLarge:
    'الملفات الأكبر من ${fileSize} غير مدعومة للتنقيح في الوقت الحالي. قم بتحسين حجم المستند وحاول مرة أخرى.',
  RedactSaveDialogTitle: 'حفظ كمستند منقح جديد',
  MultipleDocumentsErrorDescription:
    'تعذر معالجة المستندات ${numberOfDocuments} تم وضع علامة عليها. يمكنك محاولة تحميل المستند مرة أخرى.',
  SingleDocumentErrorDescription:
    '1 تعذر معالجة المستند الذي تم وضع علامة عليه. يمكنك محاولة تحميل المستند مرة أخرى.',
  MultipleDocumentsInProgressDescription:
    '${numberOfDocuments} المستندات التي تم وضع علامة عليها لم تنته من المعالجة.',
  SingleDocumentInProgressDescription:
    '1 المستند الذي تم وضع علامة عليه لم تنته من المعالجة.',
  CancelBulkRedaction: 'إلغاء التنقيح المجمع',
  CancelBulkRedactionMessage: `أنت على وشك إيقاف عملية التنقيح.
  سيؤدي إيقاف التنقيح إلى إيقاف التنقيح في المستند الحالي وإعادتك إلى فهرس المستند.`,
  StopRedaction: 'إيقاف التنقيح',
  DocumentLocation: 'موقع المستند',
  SecurityControls: 'الضوابط الأمنية',
  SecuritySettings: 'إعدادات الأمان',
  UseFolderSecurityFrom: 'استخدام إعدادات أمان المجلد من',
  UseSecurityFromOpenedDocument: 'استخدام إعدادات التأمين من المستند المفتوح',
  UseSecurityFromOriginalDocument: 'استخدام إعدادات التأمين من المستند الأصلي',
  UseSecurityFromOriginalFolder: 'استخدام إعدادات الأمان من المجلد الأصلي',
  UseSecurityFromOriginalFoldersAndDocuments:
    'استخدام إعدادات الأمان من المجلدات الأصلية والمستندات الأصلية',
  DocumentWillBeDisabledByDefault: 'سيتم تعطيل المستند افتراضيا.',
  DocumentsAndFoldersWillBeDisabledByDefault:
    'سيتم تعطيل المجلدات والمستندات افتراضيا.',
  ImportDataRoomError:
    'الاستيراد باستخدام ${trackingId} trackingId هو خطأ. يرجى المحاولة مرة أخرى.',
  RedactionError: 'تعذر تنقيح ${fileName}، يرجى المحاولة مرة أخرى.',
  RedactionHowRedactionSavingWorks: 'كيفية عمل حفظ التنقيح',
  RedactionEducationDialogForAdministrators: 'للمسؤولين',
  RedactionEducationDialogForGuests: 'للضيوف',
  RedactionEducationDialogPreviewDownload: 'معاينة/تنزيل',
  RedactionEducationDialogEditing: 'التحرير',
  RedactionEducationDialog1Layer: 'مستند من 1 طبقة',
  RedactionEducationDialog2Layer: 'وثيقة 2 طبقة',
  RedactionEducationDialogRedactionsAreBakedIn: 'التنقيحات مخبوزة',
  RedactionEducationDialogRedactionsAreEditable: 'التنقيحات قابلة للتحرير',
  RedactionSaveAsNewDocument: 'حفظ كمستند جديد',
  RedactionHowSavingWorks: 'كيف يعمل الحفظ',
  ChangesYouMadedWillNotBeSaved: 'لن يتم حفظ التغييرات التي أجريتها.',
  IsRedacted: 'تم تنقيحه.',
  DocumentsAddedFrom: 'الوثائق المضافة من ${dataroomName}.',
  GoToFile: 'أرني المستند',
  GoToImportFolder: 'أرني المجلد',
  Thanks: 'شكرا',
  Validation_DuplicatedDocumentInFolder:
    '${documentName} المستندات موجودة بالفعل في ${folderName}',
  Validation_NameCannotBeEmpty: 'لا يمكن أن يكون الاسم فارغا.',
  Continue: 'استمر',
  RedactingMessage: 'قد يستغرق التنقيح بعض الوقت. من فضلك لا تقم بالتحديث',
  Name: 'اسم',
  Number: 'رقم',
  LearnMore: 'التعرف على المزيد',
  BulkActionsNoItemsWillBeAffected: 'لن تتأثر أي عناصر بهذه العملية.',
  Saving: 'حفظ',
  YouCanKeepWorking: 'يمكنك الاستمرار في العمل.',
  Copy: 'نسخ',
  CopyDocument: 'نسخ المستند إلى',
  CopyFolder: 'نسخ المجلد إلى',
  Import: 'استورد',
  DataRooms: 'غرف البيانات',
  Accept: 'تقبل',
  TermOfAccess: 'شروط الوصول',
  TermOfAccessCheckbox: 'لقد قرأت وفهمت ووافقت على الشروط',
  ImportingDataFrom: 'إضافة مستندات من ${dataroomName}.',
  Refresh: 'تحديث',
  ImportTo: 'استيراد إلى',
  ImportError: 'خطأ في الاستيراد ، يرجى الاتصال بالمسؤول.',
  Back: 'ظهر',
  LastAccessed: 'الوصول اليها',
  NeverAccessed: 'لم يتم الوصول إليها مطلقا',
  Remaining: 'باق',
  SubmissionWindowIsOpen: 'نافذة التقديم مفتوحة.',
  SubmissionWindowHasEnd:
    'انتهت نافذة التقديم. سيتم وضع علامة على المستندات التي تقوم بتحميلها الآن على أنها متأخرة.',
  FromYourComputer: 'من جهاز الكمبيوتر الخاص بك',
  FromAnotherDataRoom: 'من غرفة بيانات أخرى',
  FromFolderStructure: 'من بنية المجلد',
  FromDataRoom: 'من غرفة البيانات',
  AddFromDataRoom: 'إضافة من غرفة البيانات',
  AddFromFolderStructure: 'إضافة من بنية المجلد',
  ImportDialogDataRoomScreenDialogTitle: 'إضافة مستندات من غرفة البيانات',
  ImportDialogDataRoomScreenHeading:
    'اختر غرفة البيانات التي تحتوي على المستندات التي تريد إضافتها.',
  ImportDialogTermOfAccessScreenDialogTitle: 'إضافة مستندات من ${dataroomName}',
  ImportDialogTermOfAccessScreenHeading:
    'تحتاج إلى قبول شروط الوصول قبل أن تتمكن من إضافة مستندات من غرفة البيانات هذه.',
  ImportDialogDataRoomScreenRadioBtn: 'إضافة مستندات من غرفة البيانات هذه',
  ImportDialogDocumentListScreenHeading:
    'اختر مستندا واحدا أو أكثر لإضافته إلى غرفة البيانات.',
  ImportDialogEmptyDataRoom: 'لا توجد غرف بيانات يمكنك الوصول إليها.',
  ImportDialogEmptyDocument: 'لا توجد مستندات لإضافتها من غرفة البيانات هذه.',
  ImportDialogDocumentListScreenDialogTitle: 'إضافة مستندات من ${dataroomName}',
  UserTypeCode_ADM: 'مدير',
  UserTypeCode_DOP: 'ناشر',
  UserTypeCode_GUE: 'ضيف',
  UserTypeCode_USQ: 'برنامج المشاهدين المحدودين',
  UserTypeCode_USR: 'المشاهد',
  QnaRoleCode_QVW: 'عارض الأسئلة',
  QnaRoleCode_BAP: 'مقدم العطاء المعتمد',
  QnaRoleCode_BAA: 'مؤلف العارض',
  QnaRoleCode_BMC: 'جهة الاتصال الرئيسية لمقدم العطاء',
  QnaRoleCode_IAP: 'المعتمد الداخلي',
  QnaRoleCode_IAA: 'مؤلف داخلي',
  QnaRoleCode_IMC: 'جهة الاتصال الرئيسية الداخلية',
  QnaRoleCode_IOB: 'مراقب داخلي',
  QnaRoleCode_QAU: 'مؤلف السؤال',
  QnaRoleCode_QAP: 'الموافقة على السؤال',
  QnaRoleCode_ADR: 'أجب الصياغة',
  QnaRoleCode_AAU: 'مؤلف الإجابة',
  QnaRoleCode_AAP: 'الموافقة على الإجابة',
  QnaRoleCode_QAA: 'مسؤول الأسئلة والأجوبة',
  QnaRoleCode_QAO: 'مراقب سؤال وجواب تحكم كامل',
  QnaRoleCode_QOV: 'سؤال وجواب عرض المراقب فقط',
  DemoRoom: '* تجريبي * - ${dataroomName}',
  SearchDocuments_InputPlaceholder:
    'أدخل كلمة أساسية أو اسما ورقما لمستند أو مجلد',
  SearchDocuments_Find: 'وجد',
  SearchDocuments_Results: 'النتائج',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} وثيقة${plural} سوف يطابق المحتوى',
  SearchDocuments_DocumentSummary:
    '${totalItems} وثيقة${plural} سوف تتطابق مع العنوان والرقم والرمز',
  SearchDocuments_FolderSummary:
    '${totalItems} المجلد${plural} سوف يطابق العنوان والرقم والرمز',
  New: 'الجديد',
  Browse: 'تصفح',
  ImportFolder_GlobalActionButton: 'استيراد بنية المجلد',
  ImportFolder_Title: 'استيراد بنية المجلد',
  ImportFolder_Step1_DragDropDescription1:
    'قم بسحب ملف Excel وإفلاته أو استعراضه لاستيراد المجلدات.',
  ImportFolder_Step1_DragDropDescription2:
    'ملاحظة: يتم تعطيل المجلدات عند الاستيراد.',
  ImportFolder_Step1_DragDropDescription3:
    'قم بتنسيق ملف Excel الخاص بك باستخدام رقم المجلد كعمود A واسم المجلد كعمود B أو ببساطة {0}',
  ImportFolder_Step1_FileUploaded: '{0إغلاقتم تحميل الدعامة',
  ImportFolder_Step1_DownloadTemplateFile: 'تنزيل قالب اكسل',
  ImportFolder_Step1_Heading: 'أنت تقوم باستيراد بنية المجلد إلى {0}',
  ImportFolder_Step1_ErrorMessage:
    'لم يتم تحميل ملفك. حاول مرة أخرى باستخدام ملف .xls أو .xlsx.',
  ImportFolder_Step2_Title: 'مراجعة الاستيراد وإكماله',
  ImportFolder_Step2_SuccessMessage: 'تم استيراد مجلداتك.',
  Document_Preview: 'معاينة المستند',
  FileUnsupportedForPreview: `We can’t show you a preview of this file.
    You’ll need to download the file to view the contents.`,
  ErrorWhileDownloadingFile:
    'يوجد خطأ أثناء محاولة التنزيل ، يرجى الاتصال بدعم العملاء لدينا مع ${ErrorCode}',
  CannotDownloadingFile: 'لا يمكن تنزيل الملف. ',
  ClickToSeeDetails: 'انقر لرؤية التفاصيل',
  TryAgain: 'حاول مرة أخرى',
  NumberingUpdatedFor: 'تم تحديث الترقيم ل',
  Items: 'العناصر',
  YoureAboutToChangeTheNumberingOn: 'أنت على وشك تغيير الترقيم على',
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    'قد يكون لهذا تأثير على الأشخاص الذين يشيرون إلى المستند في هذا المشروع.',
  AllDocuments: 'جميع الوثائق',
  AllQnaAndAttachments: 'جميع الأسئلة والأجوبة والمرفقات',
  AllSubmissionDocuments: 'جميع وثائق التقديم',
  AllEvaluationAttachments: 'جميع مرفقات التقييم',
  AllUserActivityDocumentViewsReports:
    'جميع سجلات النشاط حسب الشخص وتقارير طرق عرض المستندات',
  IncludeDocuments: 'تضمين المستندات',
  IncludeSubmissionDocuments: 'تضمين مستندات التقديم',
  IncludeEvaluationAttachments: 'تضمين مرفقات التقييم',
  IncludeQna: 'تضمين سؤال وجواب',
  IncludeQnaAttachments: 'تضمين مرفقات س&ج',
  IncludeDisabledDocuments: 'تضمين المستندات المعطلة',
  Documents: 'الوثائق',
  SubmissionDocuments: 'وثائق التقديم',
  EvaluationAttachments: 'مرفقات التقييم',
  QnaAttachments: 'مرفقات الأسئلة والأجوبة',
  DisabledDocuments: 'المستندات المعطلة',
  DocumentsVisibleTo: 'المستندات المرئية ل',
  SubmissionDocumentsVisibleTo: 'وثائق التقديم مرئية ل',
  QnaAndAttachmentsVisibleTo: 'س&س&جونج والمرفقات المرئية ل',
  QnaAttachmentsVisibleTo: 'مرفقات س&ج مرئية ل',
  QnaVisibleTo: 'سؤال وجواب مرئي ل',
  IncludeDisabledDocumentsWarningMessage:
    'سيؤدي تضمين المستندات المعطلة إلى الكشف عن المستندات غير المرئية حاليا للفريق المحدد. هذا الخيار غير مستحسن.',
  AllSubTeams: 'جميع الفرق الفرعية',
  AllSecurityGroups: 'جميع مجموعات الأمان',
  NoSubTeams: 'لا توجد فرق فرعية',
  AdminOnlyFullArchive: 'المشرف فقط - أرشيف كامل',
  Team: 'فريق',
  SubTeam: 'الفريق الفرعي',
  ArchiveName: 'اسم الأرشيف',
  Options: 'خيارات',
  Summary: 'ملخص',
  CreateArchive: 'إنشاء أرشيف',
  IncludeInArchive: 'تضمين في الأرشيف',
  VisibleTo: 'مرئي ل',
  SubmissionDocuments_LowerCase: 'وثائق التقديم',
  EvaluationAttachments_LowerCase: 'مرفقات التقييم',
  Qna: 'سؤال وجواب',
  QnaAndAttachments_LowerCase: 'مرفقات الأسئلة والأجوبة',
  DisableDocuments_LowerCase: 'المستندات المعطلة',
  Questions_LowerCase: 'الاسئله',
  Attachments_LowerCase: 'المرفقات',
  DocumentViewsReports_LowerCase: 'تقارير طرق عرض المستندات',
  ActivityLogsByPerson_LowerCase: 'سجلات النشاط حسب الشخص',
  InProgress: 'قيد التنفيذ',
  Expired: 'انتهت',
  Failed: 'فشل',
  YourArchiveIsBeingGenerated: 'يتم إنشاء الأرشيف الخاص بك ...',
  YourArchiveHasBeenQueued: 'تم وضع الأرشيف الخاص بك في قائمة الانتظار.',
  AnEmailWillBeSentTo: 'سيتم إرسال بريد إلكتروني إلى',
  WithADownloadLinkWhenTheArchiveIsReady:
    'مع رابط التنزيل عندما يكون الأرشيف جاهزا.',
  ContactSupport: 'الاتصال بالدعم',
  SomethingWentWrong: 'حدث خطأ ما.',
  WeAreUnableToProcessYourArchiveRequest:
    'لا يمكننا معالجة طلب الأرشيف الخاص بك.',
  Retrieving: 'استرداد',
  FullArchiveAdminOnly: 'الأرشيف الكامل - المسؤول فقط',
  Filtered: 'تصفيه',
  CreateYourFirstArchive: 'أنشئ أرشيفك الأول.',
  AutoTruncateHelpText:
    'سنطبق أفضل اقتطاع لضمان عدم تجاوز مسارات الملفات 260 حرفا.',
  Becomes_LowerCase: 'يصبح',
  TruncationType: 'نوع الاقتطاع',
  AutoTruncate: 'اقتطاع تلقائي',
  DoNotTruncate: 'لا تقتطع',
  KeepLastSegmentOfNumbers: 'الاحتفاظ بالمقطع الأخير من الأرقام',
  KeepNumbersOnly: 'الاحتفاظ بالأرقام فقط',
  KeepNamesOnly: 'الاحتفاظ بالأسماء فقط',
  FullArchiveHelpText:
    'يمكن لمسؤولي غرفة البيانات عرض جميع المستندات ومرفقات الأسئلة والأجوبة.',
  ArchiveHelpText:
    'سنقوم بتضمين ${includedOptions} مرئية ${teamOrSubTeamName}.',
  HowArchivesWork: 'كيفية عمل الأرشيفات',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    'تحتوي الأرشيفات على مسار الملف الكامل لكل مستند مؤرشف.',
  FilePathsAreLimitedTo260Characters: 'تقتصر مسارات الملفات على 260 حرفا.',
  YouMayNeedToTruncateTheFilePaths:
    'قد تحتاج إلى اقتطاع مسارات الملفات بحيث يمكنك عرضها على جهاز الكمبيوتر الخاص بك.',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    'بدلا من ذلك ، يمكنك استخدام تطبيق ZIP لعرض الأرشيفات ذات مسارات الملفات الطويلة.',
  YourArchiveIsDownloading: 'يتم تنزيل الأرشيف الخاص بك.',
  DoNotTruncateHelpText:
    'يمكنك استخدام تطبيق ZIP لاستخراج المستندات ذات مسارات الملفات الطويلة.',
  Share: 'سهم',
  SecureShare_Capitalize: 'مشاركة آمنة',
  SecureShare_SentenceCase: 'مشاركة آمنة',
  ValidateEmailToView: 'التحقق من صحة البريد الإلكتروني لعرضه',
  ValidateEmailToViewDescription:
    'سيحتاج الأشخاص إلى التحقق من صحة عنوان بريدهم الإلكتروني قبل عرض المستند.',
  EnterPasscodeToView: 'أدخل رمز المرور لعرضه',
  EnterPasscodeToViewDescription:
    'قم بتعيين رمز مرور للأشخاص لإدخاله قبل أن يتمكنوا من عرض المستند.',
  AnyoneWithALinkCanView: 'يمكن لأي شخص لديه رابط عرض',
  AnyoneWithALinkCanViewDescription:
    'سيكون لدى الأشخاص الذين لديهم الرابط وصول غير آمن إلى المستند.',
  NoAccess: 'ممنوع الوصول',
  NoAccessDescription:
    'لم يعد بإمكان الأشخاص الذين لديهم روابط مشتركة عرض المستند.',
  SecureShareLinkSettings: 'التحكم في الوصول إلى الرابط المشترك',
  Watermark: 'العلامه المائيه',
  LinkExpiresIn: 'تنتهي صلاحية الرابط في ${duration} (${timezone})',
  LinkExpiredDuration: 'انتهت صلاحية الرابط منذ ${duration} (${timezone})',
  LinkExpirationDate: 'تعيين تاريخ ووقت لانتهاء صلاحية الرابط',
  On: 'على',
  Off: 'قباله',
  CreateWatermark: 'إنشاء علامة مائية',
  None: 'اي',
  YouAreReadyToShare: 'أنت جاهز للمشاركة',
  WeHaveCopiedTheSecureShareLinkToYourClipboard:
    'لقد نسخنا الرابط الآمن ل <بيانات قوية-ansarada-ccd = "true">${fileName}</strong> إلى الحافظة الخاصة بك.',
  AnyoneWithTheLinkCanviewTheDocument: 'يمكن لأي شخص لديه الرابط عرض المستند.',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    'يحتاج الأشخاص إلى التحقق من صحة بريدهم الإلكتروني لعرض المستند.',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    'يحتاج الأشخاص إلى إدخال رمز المرور (<بيانات قوية-ansarada-ccd="true">${passCode}</strong>) لعرض المستند.',
  SecureShareLink: 'رابط المشاركة الآمنة',
  SecureShareLinkCopy: 'رابط آمن لك لنسخه ومشاركته',
  SaveAndRemoveAccess_SentenceCase: 'حفظ حق الوصول وإزالته',
  AccessPasscode: 'أدخل رمز مرور للوصول إلى الرابط',
  SettingsSaved: 'الإعدادات المحفوظة',
  WeHaveExpiredAllSecureShareLinks:
    'لقد انتهت صلاحية جميع روابط المشاركة الآمنة ل <بيانات قوية-ansarada-ccd = "true" >${fileName}</strong>.',
  LinkShareWithCode: 'مشاركة الارتباط مع التعليمات البرمجية',
  LinkShareWithEmail: 'مشاركة الرابط مع البريد الإلكتروني',
  LinkShare: 'مشاركة الرابط',
  AllDownloadedCopiesWillSelfDestruct:
    'جميع النسخ التي تم تنزيلها سوف تدمر نفسها.',
  NeedHelpSharingALinkOrDocument:
    'هل تحتاج إلى مساعدة في مشاركة رابط أو مستند؟',
  HowDoIExpireAllLinksToADocument:
    'كيف يمكنني إنهاء صلاحية جميع الروابط إلى مستند؟',
  WhatDoIDoToDenyADownload: 'ماذا أفعل لرفض التنزيل؟',
  FindOutMoreAboutSecureShare: 'تعرف على المزيد حول مشاركة المستندات بأمان',
  SaveAndCopyLink_SentenceCase: 'حفظ الرابط ونسخه',
  ShareDocumentSecurely_SentenceCase: 'مشاركة المستند بأمان',
  ShareDocumentEmptyStateDescription:
    'اختر مستندا من عمود إدارة المستندات لبدء المشاركة.',
  FirstTellUsWhoYouAre: 'أولا ، أخبرنا من أنت',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    'للوصول إلى المستند المشترك ، نحتاج إلى التحقق من عنوان بريدك الإلكتروني.',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    'سنرسل إليك بريدا إلكترونيا حتى تتمكن من الوصول إلى المستند المشترك.',
  EnterAnEmailAddress: 'أدخل عنوان بريد إلكتروني',
  EnterAValidEmailAddress: 'أدخل عنوان بريد إلكتروني صالح',
  EmailIsRequired: 'البريد الإلكتروني مطلوب',
  VerifyMyEmail_SentenceCase: 'التحقق من بريدي الإلكتروني',
  FirstEnterThePasscode: 'أولا ، أدخل رمز المرور',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    'للوصول إلى المستند المشترك ، تحتاج إلى إدخال رمز المرور.',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    'تواصل مع الشخص الذي شارك الرابط معك لمعرفة المزيد.',
  EnterTheAccessPasscode: 'أدخل رمز مرور الوصول',
  ViewDocument_SentenceCase: 'عرض الملف',
  TheDocumentIsNoLongerAvailable: 'المستند لم يعد متوفرا',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    'ربما تمت إزالة وصولك أو حذف المستند.',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    'تواصل مع الشخص الذي شارك الرابط معك لمعرفة المزيد.',
  SecurityControlsOn: 'الضوابط الأمنية على',
  SecurityControlsOff: 'إيقاف تشغيل عناصر التحكم الأمنية',
  CopyingAllowed: 'النسخ مسموح به',
  CopyingDenied: 'تم رفض النسخ',
  EditingAllowed: 'التحرير مسموح به',
  EditingDenied: 'تم رفض التحرير',
  DenyCopyingDisabled: 'رفض النسخ معطل',
  DenyEditingDisabled: 'رفض تعطيل التحرير',
  DenyPrintingDisabled: 'رفض تعطيل الطباعة',
  DenySavingDisabled: 'رفض الحفظ معطل',
  Redirecting: 'اعاده توجيه...',
  CheckYourInbox: 'التحقق من البريد الوارد',
  YouAreOnADifferentDevice: 'أنت تستخدم جهازا مختلفا',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    'يمكنك فقط عرض هذا المستند من نفس الجهاز المستخدم للتحقق من بريدك الإلكتروني.',
  WeHaveSentAnEmailToYourEmail: 'لقد أرسلنا بريدا إلكترونيا إلى ',
  WithTheAccessToViewTheDocument: ' مع إمكانية الوصول لعرض المستند.',
  ViewActivity: 'عرض النشاط',
  PasscodeIsNotCorrect: 'رمز المرور غير صحيح',
  SubmissionDocumentUploaded: '1 وثيقة تم تحميلها في التقديم.',
  SubmissionDocumentsUploaded:
    '${NumberOfDocuments} المستندات التي تم تحميلها في التقديم.',
  HowSubmissionsWork: 'آلية عمل عمليات الإرسال',
  AllAddedDocumentsAreAutomaticallySubmitted:
    'يتم تقديم جميع المستندات المضافة تلقائيا.',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    'لديك حتى إغلاق نافذة التقديم لإجراء التغييرات.',
  UntilClose: 'حتى الإغلاق',
  Ansarada: 'أنسارادا',
  BulkEditFileUpload: `أو قم بسحب وإسقاط Excel المكرر هنا. نحن'
  overview of the edits.`,
  BulkEditFileUploadAfterUploading:
    'أو اسحب الملف الصحيح وأفلته هنا للتبديل بسلاسة.',
  BulkEditExcelReady:
    'على نقطة ، ${name}! هل جهزت برنامج Excel الذي تم تحريره؟',
  BeforeYourEdits: 'قبل تعديلاتك',
  AfterYourEdits: 'بعد تعديلاتك',
  DropFilesHereToAttach: 'قم بإسقاط الملفات هنا لإرفاقها',
  KickOffBy: 'انطلاق المباراة بواسطة',
  DownloadingTheExcelVersion: 'تنزيل إصدار Excel',
  OfYourDocumentIndex: 'من فهرس المستند.',
  BulkEditNextButtonGuide:
    'بعد الضبط الدقيق ، انقر فوق <strong>الزر "التالي</strong>" للتحميل ومشاهدة الكفاءة أثناء العمل.',
  BulkEditDownloadExcelFileHeading:
    'ارتق بسير عملك: أصبح تحرير المستندات سلسا.',
  BulkEditAllSetHeading: 'كل مجموعة ، ${name}! أنت مستعد للعمل.',
  BulkEditButtonGuide:
    'بمجرد الضغط على زر <strong>التحرير المجمع</strong> ، نحن على استعداد لتعديل ${combinedText} وفقا لتوجيهاتك.',
  HeadsUpThough: `<strong>مجرد تنبيه:</strong> لن نطبق تعديلا واحدا على الأقل. قام المسؤولون بإزالتها من فهرس المستندات.`,
  ProTip: 'نصيحة مؤيدة؟',
  ProTipDescription:
    'ضع في اعتبارك تنزيل أحدث إصدار من Excel من فهرس المستند. سيعطيك لقطة نقية قبل بدء التعديلات.',
  GrabItHere: 'احصل عليه هنا.',
  BulkEditSuccessMessage: `يتم تطبيق التحديث المجمع الخاص بك والآن في فهرس المستند. نحن نساندك!`,
  NotTheRightExcel: 'ليس إكسل الصحيح؟',
  UploadFailedMessage:
    'فشل التحميل ، ${name}. حدثت مشكلة أثناء التحميل. يرجى المحاولة مرة أخرى.',
  FailedMessage:
    'فشل التحديث ، ${name}. حدثت مشكلة في التحديث المجمع. يرجى المحاولة مرة أخرى.',
  DoNotHaveAccessMessage:
    'لا يمكنك الوصول إلى بعض المستندات والمجلدات التي تم تغييرها في Excel المقدم ، يرجى مطالبة مسؤول غرفة البيانات بإجراء العملية',
};
